/**
 * Airport coords + city names for the Live Map.
 *
 * Covers Air Canada's mainline + regional network. Anything not in this list
 * still renders the aircraft, we just don't draw the origin/destination
 * markers or the great-circle arc.
 *
 * Format: ICAO → { city, lat, lon }
 */
export const AIRPORTS = {
  // Canada — mainline hubs
  CYYZ: { city: "Toronto",       lat: 43.6772, lon: -79.6306 },
  CYUL: { city: "Montréal",      lat: 45.4706, lon: -73.7408 },
  CYVR: { city: "Vancouver",     lat: 49.1967, lon: -123.1815 },
  CYYC: { city: "Calgary",       lat: 51.1215, lon: -114.0076 },
  CYOW: { city: "Ottawa",        lat: 45.3225, lon: -75.6692 },
  CYHZ: { city: "Halifax",       lat: 44.8808, lon: -63.5086 },
  CYEG: { city: "Edmonton",      lat: 53.3097, lon: -113.5801 },
  CYWG: { city: "Winnipeg",      lat: 49.9100, lon: -97.2399 },
  CYQB: { city: "Québec City",   lat: 46.7911, lon: -71.3933 },
  CYQR: { city: "Regina",        lat: 50.4319, lon: -104.6659 },
  CYXE: { city: "Saskatoon",     lat: 52.1708, lon: -106.6997 },
  CYQT: { city: "Thunder Bay",   lat: 48.3719, lon: -89.3239 },
  CYQM: { city: "Moncton",       lat: 46.1122, lon: -64.6786 },
  CYYT: { city: "St. John's",    lat: 47.6186, lon: -52.7519 },
  CYYJ: { city: "Victoria",      lat: 48.6469, lon: -123.4258 },
  CYLW: { city: "Kelowna",       lat: 49.9561, lon: -119.3778 },
  CYXY: { city: "Whitehorse",    lat: 60.7095, lon: -135.0672 },
  CYZF: { city: "Yellowknife",   lat: 62.4628, lon: -114.4406 },
  CYQX: { city: "Gander",        lat: 48.9369, lon: -54.5681 },
  CYSJ: { city: "Saint John",    lat: 45.3161, lon: -65.8903 },
  // USA
  KJFK: { city: "New York",      lat: 40.6413, lon: -73.7781 },
  KLGA: { city: "New York",      lat: 40.7772, lon: -73.8726 },
  KEWR: { city: "Newark",        lat: 40.6895, lon: -74.1745 },
  KLAX: { city: "Los Angeles",   lat: 33.9416, lon: -118.4085 },
  KSFO: { city: "San Francisco", lat: 37.6213, lon: -122.3790 },
  KORD: { city: "Chicago",       lat: 41.9742, lon: -87.9073 },
  KDFW: { city: "Dallas/Ft W.",  lat: 32.8998, lon: -97.0403 },
  KATL: { city: "Atlanta",       lat: 33.6407, lon: -84.4277 },
  KMIA: { city: "Miami",         lat: 25.7959, lon: -80.2870 },
  KFLL: { city: "Fort Lauderdale", lat: 26.0742, lon: -80.1506 },
  KBOS: { city: "Boston",        lat: 42.3656, lon: -71.0096 },
  KIAD: { city: "Washington",    lat: 38.9445, lon: -77.4558 },
  KIAH: { city: "Houston",       lat: 29.9902, lon: -95.3368 },
  KDEN: { city: "Denver",        lat: 39.8561, lon: -104.6737 },
  KSEA: { city: "Seattle",       lat: 47.4502, lon: -122.3088 },
  KLAS: { city: "Las Vegas",     lat: 36.0840, lon: -115.1537 },
  KPHX: { city: "Phoenix",       lat: 33.4342, lon: -112.0116 },
  // Europe
  EGLL: { city: "London",        lat: 51.4700, lon: -0.4543 },
  EGKK: { city: "London LGW",    lat: 51.1481, lon: -0.1903 },
  EGCC: { city: "Manchester",    lat: 53.3537, lon: -2.2750 },
  EGPH: { city: "Edinburgh",     lat: 55.9500, lon: -3.3725 },
  EIDW: { city: "Dublin",        lat: 53.4213, lon: -6.2701 },
  LFPG: { city: "Paris CDG",     lat: 49.0097, lon: 2.5479 },
  EHAM: { city: "Amsterdam",     lat: 52.3086, lon: 4.7639 },
  EDDF: { city: "Frankfurt",     lat: 50.0379, lon: 8.5622 },
  EDDM: { city: "Munich",        lat: 48.3538, lon: 11.7861 },
  LEMD: { city: "Madrid",        lat: 40.4936, lon: -3.5668 },
  LEBL: { city: "Barcelona",     lat: 41.2974, lon: 2.0785 },
  LIRF: { city: "Rome",          lat: 41.8003, lon: 12.2389 },
  LOWW: { city: "Vienna",        lat: 48.1103, lon: 16.5697 },
  LSZH: { city: "Zürich",        lat: 47.4647, lon: 8.5492 },
  LTFM: { city: "Istanbul",      lat: 41.2606, lon: 28.7419 },
  // Asia / Pacific
  RJTT: { city: "Tokyo Haneda",  lat: 35.5494, lon: 139.7798 },
  RJAA: { city: "Tokyo Narita",  lat: 35.7647, lon: 140.3864 },
  RKSI: { city: "Seoul",         lat: 37.4602, lon: 126.4407 },
  ZBAA: { city: "Beijing",       lat: 40.0801, lon: 116.5846 },
  ZSPD: { city: "Shanghai",      lat: 31.1443, lon: 121.8083 },
  VHHH: { city: "Hong Kong",     lat: 22.3080, lon: 113.9185 },
  WSSS: { city: "Singapore",     lat: 1.3644,  lon: 103.9915 },
  VIDP: { city: "Delhi",         lat: 28.5562, lon: 77.1000 },
  VOMM: { city: "Chennai",       lat: 12.9941, lon: 80.1709 },
  YSSY: { city: "Sydney",        lat: -33.9399, lon: 151.1753 },
  // Middle East / Africa
  OMDB: { city: "Dubai",         lat: 25.2532, lon: 55.3657 },
  OMAA: { city: "Abu Dhabi",     lat: 24.4330, lon: 54.6511 },
  OTHH: { city: "Doha",          lat: 25.2731, lon: 51.6080 },
  OERK: { city: "Riyadh",        lat: 24.9576, lon: 46.6988 },
  HECA: { city: "Cairo",         lat: 30.1219, lon: 31.4056 },
  FAOR: { city: "Johannesburg",  lat: -26.1367, lon: 28.2411 },
  // Latin America / Caribbean
  MMMX: { city: "Mexico City",   lat: 19.4361, lon: -99.0719 },
  MMUN: { city: "Cancún",        lat: 21.0365, lon: -86.8771 },
  SBGR: { city: "São Paulo",     lat: -23.4356, lon: -46.4731 },
  SBGL: { city: "Rio de Janeiro", lat: -22.8100, lon: -43.2506 },
  SAEZ: { city: "Buenos Aires",  lat: -34.8222, lon: -58.5358 },
  TNCA: { city: "Aruba",         lat: 12.5014, lon: -70.0152 },
  MKJP: { city: "Kingston",      lat: 17.9357, lon: -76.7875 },
  MDPC: { city: "Punta Cana",    lat: 18.5674, lon: -68.3634 },
  TJSJ: { city: "San Juan",      lat: 18.4394, lon: -66.0018 },
};

/**
 * [lat, lon] for an airport: the position the server sent (orig_pos /
 * dest_pos, from the portal's own airport table) when there is one, otherwise
 * this list. The list alone was the whole answer once, and a flight from an
 * airport not on it (MMMY, reported 2026-10-04) had no airport markers and no
 * route line at all. Null when neither knows it.
 */
export function airportLatLon(icao, sent) {
  if (Array.isArray(sent) && sent.length >= 2) {
    const lat = Number(sent[0]);
    const lon = Number(sent[1]);
    if (Number.isFinite(lat) && Number.isFinite(lon)) return [lat, lon];
  }
  const ap = AIRPORTS[String(icao || "").toUpperCase()];
  return ap ? [ap.lat, ap.lon] : null;
}

const R_NM = 3440.065;
const RAD = Math.PI / 180;
const DEG = 180 / Math.PI;

/** Haversine great-circle distance in nautical miles. */
export function haversineNm(a, b) {
  if (!a || !b || !a[0] || !b[0]) return 0;
  const p1 = a[0] * RAD;
  const p2 = b[0] * RAD;
  const dp = (b[0] - a[0]) * RAD;
  const dl = (b[1] - a[1]) * RAD;
  const h = Math.sin(dp / 2) ** 2 + Math.cos(p1) * Math.cos(p2) * Math.sin(dl / 2) ** 2;
  return 2 * R_NM * Math.asin(Math.min(1, Math.sqrt(h)));
}

/**
 * Great-circle arc between two lat/lon points as an array of [lat, lon]
 * waypoints. Handles dateline wrap by keeping longitudes monotonic.
 */
export function greatCircleArc(from, to, steps = 64) {
  if (!from || !to || !from[0] || !to[0]) return [];
  if (Math.abs(from[0]) > 90 || Math.abs(to[0]) > 90) return [];
  const lat1 = from[0] * RAD, lon1 = from[1] * RAD;
  const lat2 = to[0] * RAD,   lon2 = to[1] * RAD;
  const d = 2 * Math.asin(Math.sqrt(
    Math.sin((lat2 - lat1) / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin((lon2 - lon1) / 2) ** 2,
  ));
  if (!d || isNaN(d)) return [];
  const pts = [];
  let prev = null;
  for (let i = 0; i <= steps; i++) {
    const f = i / steps;
    const A = Math.sin((1 - f) * d) / Math.sin(d);
    const B = Math.sin(f * d) / Math.sin(d);
    const x = A * Math.cos(lat1) * Math.cos(lon1) + B * Math.cos(lat2) * Math.cos(lon2);
    const y = A * Math.cos(lat1) * Math.sin(lon1) + B * Math.cos(lat2) * Math.sin(lon2);
    const z = A * Math.sin(lat1) + B * Math.sin(lat2);
    const plat = Math.atan2(z, Math.sqrt(x * x + y * y)) * DEG;
    let plng = Math.atan2(y, x) * DEG;
    if (prev !== null) {
      while (plng - prev > 180) plng -= 360;
      while (plng - prev < -180) plng += 360;
    }
    prev = plng;
    pts.push([plat, plng]);
  }
  return pts;
}

/**
 * Split a planned route at the point the aircraft has reached, so the flown
 * part and the part still ahead can be drawn differently — the same two-tone
 * treatment the great-circle estimate has always had.
 *
 * Splits at the nearest VERTEX, not the nearest point on the nearest segment.
 * A navlog fix every few dozen miles makes the difference invisible at map
 * zoom, and the exact version needs per-segment projection for every flight on
 * every refresh.
 *
 * `cur` is included in both halves so the two lines meet at the aeroplane
 * rather than leaving a gap back to the last fix.
 */
export function splitRouteAt(route, cur) {
  if (!Array.isArray(route) || route.length < 2) return { flown: [], ahead: [] };
  if (!cur) return { flown: [], ahead: route };

  let best = 0;
  let bestD = Infinity;
  for (let i = 0; i < route.length; i++) {
    const d = haversineNm(route[i], cur);
    if (d < bestD) { bestD = d; best = i; }
  }
  return {
    flown: [...route.slice(0, best + 1), cur],
    ahead: [cur, ...route.slice(best + 1)],
  };
}
